export default __webpack_public_path__ + "static/travelling-couple-2e748e6c4540005f3a391c305e223925.jpg";